import styled, { css } from 'styled-components'
import { theme } from '../theme'

export const VerticalStyledScrollBar = css<{ scrollbarBackground: string }>`
  ::-webkit-scrollbar {
    width: 20px;
  }

  ::-webkit-scrollbar-thumb {
    min-height: 70px;
    background: ${theme.colors.colordfe3e8};
    border-radius: 100px;
    border: 7px solid ${props => props.scrollbarBackground};
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${theme.colors.colorBCC9D9};
  }

  ::-webkit-scrollbar-track {
    background: ${props => props.scrollbarBackground};
    border-left: 8.5px solid transparent;
    border-right: 8.5px solid transparent;
    background-clip: padding-box;
  }

  ::-webkit-scrollbar-button {
    display: none;
  }
`

export interface DividerProps extends React.CSSProperties {
  orientation?: 'vertical' | 'horizontal'
}

export const Divider = styled.hr.attrs(({ orientation, ...rest }: DividerProps) => ({
  role: 'separator',
  orientation,
  style: { ...rest }
}))<DividerProps>`
  position: relative;
  background-color: ${theme.colors.colordfe3e8};
  color: ${theme.colors.colordfe3e8};
  border-style: solid;
  border-width: 0;

  ${({ orientation = 'horizontal' }) => {
    if (orientation === 'horizontal') {
      return css`
        border-bottom-width: 1px;
        width: 100%;
      `
    }
    if (orientation === 'vertical') {
      return css`
        border-left-width: 1px;
        height: 100%;
      `
    }
  }}
`

interface IStack extends Omit<React.CSSProperties, 'direction'> {
  direction?: React.CSSProperties['flexDirection']
  spacing?: React.CSSProperties['gap']
}

export const Stack = styled.div.attrs<IStack>(({ direction, spacing, ...rest }) => ({
  style: { ...rest }
}))<IStack>`
  position: relative;
  display: flex;
  flex-direction: ${props => props.direction ?? 'column'};
  align-items: center;
  gap: ${props => props.spacing ?? '1rem'};
`

interface IInline extends React.CSSProperties {
  spacing?: React.CSSProperties['gap']
}

export const Inline = styled.div.attrs<IInline>(({ spacing, ...rest }) => ({
  style: { ...rest }
}))<IInline>`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${props => props.spacing ?? '1rem'};
`

interface ICenter extends React.CSSProperties {}

export const Center = styled.div.attrs<ICenter>(({ ...rest }) => ({
  style: { ...rest }
}))<IStack>`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

interface ITitleProps {
  isStagingTitle?: boolean
  hideMarginTop?: boolean
}

export const Title = styled.p<ITitleProps>`
  font-weight: 600;
  color: ${props => props.theme.colors.color2d3139};
  font-family: 'Inter';
  font-size: ${({ isStagingTitle }) => (isStagingTitle ? '14px' : '13px')};
  margin-top: ${({ hideMarginTop, theme }) => (hideMarginTop ? '' : theme.zds.spacing.stack500)};
  margin-bottom: ${({ theme }) => theme.zds.spacing.stack300};
  text-transform: uppercase;
`
